import apiConfig from "../ApiConfig";


export const getBgvRecordsApi = async (userId) => {
  const res = await apiConfig.get(
    `/api/team-collaboration/bgv?user_id=${userId}`
  );
  return res.data?.data?.records || [];
};

export const getEmployeeBgvRecordsApi = async (employeeId) => {
  const res = await apiConfig.get(
    `/api/team-collaboration/bgv/record/view/${employeeId}/`
  );
  return res.data;
}

export const getEmployeePerformanceRecordsApi = async (employeeId) => {
  const res = await apiConfig.get(
    `/api/team-collaboration/performance/record/view/${employeeId}/`
  );
  return res.data;
}

// The employee's newest BGV / performance file, streamed through the backend
// (S3 links are blocked in the app by the deployed Content-Security-Policy).
export const getEmployeeBgvFileBlobApi = async (employeeId) => {
  const res = await apiConfig.get(`/api/team-collaboration/bgv/record/file/${employeeId}/`, {
    responseType: "blob",
  });
  return res.data;
};

export const getEmployeePerformanceFileBlobApi = async (employeeId) => {
  const res = await apiConfig.get(`/api/team-collaboration/performance/record/file/${employeeId}/`, {
    responseType: "blob",
  });
  return res.data;
};
